import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setGifQuality, toggleGifSound } from "store/application/application-action";
import { applyAnimation, AnimationClass } from "../utils/helpers";
import { IGif } from "services/types";

interface IUsePlayerActionsProps {
  toggleFullScreen: (gif: IGif) => void;
  gif: IGif;
  ref: React.RefObject<HTMLDivElement>;
}

export const usePlayerActions = (props: IUsePlayerActionsProps) => {
  const { toggleFullScreen, gif, ref } = props;
  const dispatch = useDispatch();

  const toggleQuality = useCallback((type: string) => dispatch(setGifQuality(type)), [dispatch]);

  const toggleSound = useCallback((sound: boolean) => {
    applyAnimation({
      ref,
      animationClass: sound ? AnimationClass.SoundOn : AnimationClass.SoundOff
    });
    dispatch(toggleGifSound(sound));
  }, [dispatch, ref]);

  const handleToggleFullScreen = useCallback(() => {
    toggleFullScreen(gif);
  }, [gif, toggleFullScreen]);

  return {
    toggleQuality,
    toggleSound,
    handleToggleFullScreen
  };
};
